import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson înființează compania London Rubber și vinde prezervative importate și accesorii',
		},
		{
			year: 1929,
			description: 'London Rubber Company înregistrează brandul Durex ca marcă înregistrată',
		},
		{
			year: '1950',
			description: 'Durex lansează primul prezervativ lubrifiat',
		},
		{
			year: 1953,
			description: 'Durex este primul brand care a dezvoltat și utilizat testarea electronică',
		},
		{
			year: '1960',
			description: 'Durex lansează primul prezervativ cu formă anatomică',
		},
		{
			year: '1970',
			description: 'Durex este primul brand de prezervative din lume care a început să difuzeze reclame publicitare în mai multe țări',
		},
		{
			year: '1990',
			description: 'Durex este primul brand de prezervative care adoptă un ,,sigiliu de calitate” ca standard global',
		},
		{
			year: 1995,
			description: 'Durex lansează o gamă de prezervative colorate și aromate',
		},
		{
			year: 1996,
			description: 'Durex este primul brand de prezervative care își creează un site web. În momentul actual avem 42 de site-uri diferite pentru țările în care suntem prezenți',
		},
		{
			year: 1997,
			description: 'Durex lansează prezervativele fără latex. Pentru noul produs este folosit un material nou, non-alergenic: poliuretanul sintetic dezvoltat de Durex este mai fin și mai elastic decât latexul din cauciuc natural',
		},
		{
			year: 1998,
			description: 'Durex este primul brand de prezervative care efectuează și publică un sondaj mondial despre satisfacția sexuală',
		},
		{
			year: 2001,
			description: 'Durex introduce Pleasuremax. Acest lucru îl califică pe Durex drept primul brand care comercializează un prezervativ care are atât striații, cât și puncte în relief',
		},
		{
			year: 2003,
			description: 'Durex lansează o gamă interesantă și captivantă de lubrifianți – gama Play',
		},
		{
			year: 2005,
			description: 'Durex lansează rapoartele ”Face of Global Sex” care analizează aspecte ale comportamentului sexual și care sunt create pentru informarea academicienilor și liderilor de decizie',
		},
		{
			year: 2008,
			description: 'Pentru a promova actul sexual protejat în rândul tinerilor, Durex încurajează tinerii cu vârstă cuprinsă între 16 și 24 de ani să creeze un poster privind sănătatea sexuală – un poster creat de ei, pentru ei',
		},
		{
			year: 2010,
			description: 'Durex susține inițiativa ”Condomize!” a Fondului Națiunilor Unite pentru Populație în cadrul Conferinței Internaționale de SIDA de la Viena, printr-o donație de 220000 de prezervative',
		},
		{
			year: 2010,
			description: 'Brandul Durex este cumpărat de către compania Reckitt Banckiser',
		},
		{
			year: 2010,
			description: 'Durex introduce Performax Intense – un prezervativ conceput pentru a-i satisface pe ambii parteneri. Cu o acoperire interioară ce conține 5% benzocaină și o structură exterioară stimulantă, acest prezervativ poate face sexul mai lung și mai intens',
		},
		{
			year: 2019,
			description: 'Durex împlinește 90 de ani',
		},
		{
			year: 2022,
			description: 'Durex își lansează noua identitate de brand',
		},
	]
}